<template>
<a :href="isWeixin?'':'/webcast.html#/publicity'" :class="current" :data-scp="scp">
	<i class="icon icon-live" v-if="!isWeixin"></i>
	<span v-if="!isWeixin">直播</span>
	<div v-if="isWeixin" v-html="wxapp"></div>
</a>
</template>

<script>
import {maple, domain} from 'tgPage';

let protocol = location.protocol
	;

export default {
	props: ['scp', 'current']
	, data(){
		return {
			isWeixin: maple.device.weixin
			, webcast: {
				userName: domain.webcast.userName
				, path: domain.webcast.path +'.html'
			}
			, protocol
			, wxapp: `<wx-open-launch-weapp username="${domain.webcast.userName}"
  path="${domain.webcast.path +'.html'}">
<script type="text/wxtag-template">
<img src="${protocol}//image1.51tiangou.com/tgou2/img2/webcast/icon-webcast.png"
 width="26"
 height="22"
 style="display: block;margin: 2px auto 0;"
 alt="">
<div style="font-size: 11px;color: #666;text-align: center;">直播</div>
<\/script>
</wx-open-launch-weapp>`
		};
	}
}
</script>
<style lang="scss">
.icon-live:before {
	content: "\ea38";
}
</style>